import client from "api/client";

// emailTemplatesApi — website-scoped /websites/{websiteId}/email-templates.
// Extracted from the inline axios calls the email-template screens used before
// the website-scoped migration.

export const listEmailTemplates = async (websiteId, { limit = 50, offset = 0, search } = {}) => {
  const params = { limit, offset, sort_by: "created_at", sort_desc: true };
  if (search) params.search = search;
  const { data } = await client.get(`/websites/${websiteId}/email-templates`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const createEmailTemplate = async (websiteId, payload) => {
  const { data } = await client.post(`/websites/${websiteId}/email-templates`, payload);
  return data;
};

export const updateEmailTemplate = async (websiteId, id, payload) => {
  const { data } = await client.put(`/websites/${websiteId}/email-templates/${id}`, payload);
  return data;
};

export const deleteEmailTemplate = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/email-templates/${id}`);
};
